
<template>
  <!--住户信息-->
  <div>
    <div class="advanced-form">
      <div class="card">
        <div class="card-head">
          <h3>{{roomName}}</h3>
        </div>
        <div class="card-body">
          <x-tabula
            :columns="columns"
            rowKey="householder_info_id"
            :rowOptList="rowOptList"
            :listApi="listApi"
            :searchParams.sync="searchParams"
            :deleteParam="deleteParam"
            :rowSelection="false"
          >
            <template slot="opt_t" slot-scope="{row}">
              <span>{{row.mobile_phone}}</span>
            </template>

            <template slot="opt_o" slot-scope="{row}">
              <span>{{row.expire_time | foreverTime}}</span>
            </template>
          </x-tabula>
        </div>
      </div>
    </div>

    <!--续期的弹窗-->
    <a-modal
      title="续期"
      :visible="visible"
      @ok="handleSubmit"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      :width="900"
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form-item label="截止时间" v-bind="$store.state.modal_ItemLayout">
        <a-date-picker v-model="expire_time" format="YYYY-MM-DD"/>
      </a-form-item>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'roomInfo',
  data () {
    return {
      roomName: '',
      householderId: '',
      visible: false,
      btnLoading: {loading: false},
      searchParams: {},
      expire_time: moment(),
      rowOptList: [
        { text: '删除', handle: (record) => this.$children[0].showDeleteConfirm(record), key: 'delete' },
        { text: '续期', handle: (record) => this.handleExpire(record), key: 'delay' }
      ],
      columns: [
        { title: '昵称', dataIndex: 'nick_name', align: 'left', width: '' },
        { title: '手机', dataIndex: 'mobile_phone', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} },
        { title: '真实姓名', dataIndex: 'household_name', align: 'left', width: '' },
        { title: '住户类型', dataIndex: 'member_type_desc', align: 'left', width: '' },
        { title: '有效期至', dataIndex: 'expire_time', align: 'left', width: '', scopedSlots: {customRender: 'action_o'} },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      listApi: {
        url: `/room/get_householder/${this.$route.query.id}`,
        resHandle: '',
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/room/householder',
        param: { pk_key: 'householder_info_id', pk_val: '' },
        title: '住户',
        key: 'nick_name'
      }
    };
  },
  created () {
    this.roomName = this.$route.query.roomName;
  },
  mounted () {
  },
  methods: {
    /* 打开弹窗 */
    handleExpire (row) {
      this.householderId = row.householder_info_id;
      this.expire_time = this.Moment(row.expire_time);
      this.visible = true;
    },
    /* 提交表单 */
    handleSubmit () {
      let expire = this.expire_time.format('YYYY-MM-DD');
      this.$put({
        url: `/room/exprie/${this.householderId}`,
        params: { expire_time: expire },
        btnLoading: this.btnLoading
      }).then((res) => {
        this.visible = false;
        this.$message.success('续期成功！').then((res) => {
          this.$router.go(-1);
        });
      }).catch(() => {
        this.visible = false;
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/baseData/room/roomInfo.vue